import React, {useCallback} from 'react';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DownloadIcon from '@mui/icons-material/Download';
import {SxProps, Box, useTheme, Tooltip, alpha} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface IconPanelProps {
  onDelete?: () => void;
  onDownload?: () => void;
  isOwnMessage: boolean;
  sx?: SxProps;
}

// TODO: Adjust margins depending on isOwnMessage and translations

const IconPanel: React.FC<IconPanelProps> = ({onDelete, onDownload, sx}) => {
  const theme = useTheme();

  const {t} = useTranslation();

  const handleDeleteOptionClick = useCallback(() => {
    if (onDelete) {
      onDelete();
    }
  }, [onDelete]);

  const handleDownloadOptionClick = useCallback(() => {
    if (onDownload) {
      onDownload();
    }
  }, [onDownload]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        ...sx
      }}
    >
      {onDelete && (
        <Tooltip title={t('delete')}>
          <DeleteForeverIcon
            sx={{
              backgroundColor: alpha(theme.palette.primary.main, 0.4),
              color: theme.palette.primary.contrastText,
              marginRight: 2
            }}
            onClick={handleDeleteOptionClick}
          />
        </Tooltip>
      )}
      {onDownload && (
        <Tooltip title={t('download')}>
          <DownloadIcon
            sx={{
              backgroundColor: alpha(theme.palette.primary.main, 0.4),
              color: theme.palette.primary.contrastText
            }}
            onClick={handleDownloadOptionClick}
          />
        </Tooltip>
      )}
    </Box>
  );
};
export default IconPanel;
